import {
    useEffect,
    useState
} from 'react';
import PurchaseByOutletDept from './PurchaseByOutlet';
import InventoryByOutlet from './InventoryByOutlet';
import Navbar from '../Navbar';
import Footer from '../Footer';

const Invent = () => {
    const [viewMode, setViewMode] = useState(() => {
        return sessionStorage.getItem("inventViewMode") || "overview";
    });
    // const viewMode = "details";

    useEffect(() => {
        sessionStorage.setItem("inventViewMode", viewMode);
    }, [viewMode]);

    return (
        <div className='flex flex-col min-h-screen bg-gray-50'>
            <Navbar />

            <div className="flex-grow pt-4">
                {/* Only for alice, hot topic */}
                <div className="px-8 w-full">
                    <div className="flex rounded-md border bg-white w-full overflow-hidden">
                        <button
                            onClick={() => setViewMode("overview")}
                            className={`flex-1 text-sm font-medium py-2 transition-colors ${viewMode === "overview"
                                ? "bg-violet-900 text-white"
                                : "bg-transparent text-gray-700 hover:bg-gray-100"
                                }`}
                        >
                            Overview
                        </button>

                        <button
                            onClick={() => setViewMode("details")}
                            className={`flex-1 text-sm font-medium py-2 transition-colors ${viewMode === "details"
                                ? "bg-violet-900 text-white"
                                : "bg-transparent text-gray-700 hover:bg-gray-100"
                                }`}
                        >
                            Details
                        </button>
                    </div>
                </div>

                {viewMode === "overview" ? (
                    <PurchaseByOutletDept viewMode={viewMode} />
                ) : (
                    <InventoryByOutlet viewMode={viewMode} />
                )}
            </div>

            <Footer />
        </div>
    );
};

export default Invent;